import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { jeMatchedLinesSelector } from 'domain/journal/selectors';
import { List } from 'immutable';
import { TEXTRACT_MATCH_STATUSES } from 'components/TextractCanvas/utils';
import { JE_TABLE_CLASSES } from 'components/Tables/grid/StyledComponents';

import cx from 'classnames';

export const withMatchingColorcoding = (WrappedComponent) => {
  class WithMatchingColorcoding extends React.Component {
    getRowStyle = (row) => {
      const { getRowStyle, headerLineNumber, lineCount, jeMatchedLines } = this.props;

      const line = row - headerLineNumber;
      const isLastRow = line === lineCount - 1; // -1 counts for header
      const match = jeMatchedLines.get(String(line), new List()).get(0, new Map());
      const matchStatus = match.get('status');

      if (isLastRow) return getRowStyle(row); // last row is not means for colorcoding, last row is technical

      return match.size > 0
        ? // $FlowFixMe
          cx(getRowStyle(row), `${JE_TABLE_CLASSES.ROW_LINE_TEXTRACT}-${matchStatus}`)
        : cx(getRowStyle(row), `${JE_TABLE_CLASSES.ROW_LINE_TEXTRACT}-${TEXTRACT_MATCH_STATUSES.DEFAULT}`);
    };

    render() {
      return <WrappedComponent {...this.props} getRowStyle={this.getRowStyle} />;
    }
  }

  WithMatchingColorcoding.displayName = WrappedComponent.displayName;

  const mapStateToProps = (state) => ({
    jeMatchedLines: jeMatchedLinesSelector(state),
  });

  return compose(connect(mapStateToProps))(WithMatchingColorcoding);
};

export default withMatchingColorcoding;
